/**
 * Keeps Magio hero cart count in sync with Dawn cart AJAX updates.
 */
(function () {
  function extractCartCount(cartData) {
    if (!cartData) return null;
    if (typeof cartData.item_count === 'number') return cartData.item_count;

    var sections = cartData.sections;
    if (!sections || !sections['cart-icon-bubble']) return null;

    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var countEl = doc.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (countEl) return parseInt(countEl.textContent, 10) || 0;
    if (!doc.querySelector('.cart-count-bubble')) return 0;
    return null;
  }

  function extractCartCountFromDom() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    if (bubble) return parseInt(bubble.textContent, 10) || 0;
    if (document.querySelector('#cart-icon-bubble') && !document.querySelector('#cart-icon-bubble .cart-count-bubble')) {
      return 0;
    }
    return null;
  }

  function updateMagioCartCount(count) {
    document.querySelectorAll('[data-magio-cart-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function onCartUpdate(event) {
    var count = extractCartCount(event.cartData);
    if (count === null) count = extractCartCountFromDom();
    if (count !== null) updateMagioCartCount(count);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }
})();
